import React, { useEffect } from "react";
import { Loader, useAPI } from "components/lib";
import { useFormBrandColor } from "components/survey/formTheme";
import { useParams } from "react-router-dom";
import { Verification } from "views/verification/page";

export function PublicVerificationEntry() {
  const params = useParams();
  const verification = useAPI(`/api/public/verification/${params.id}`);
  const isCancelled = verification?.data?.cancelled === true;
  const isTranche2Verification =
    !isCancelled && verification?.data?.type?.includes("tranche2_v1");

  // This view renders a loader inside the onboarding frame before redirecting, so
  // it takes the journey colour too — otherwise the flow opens on the default
  // purple and changes on the very next page.
  useFormBrandColor(verification?.data?.tranche2_flow?.brand_theme, !!verification?.data);

  useEffect(() => {
    if (verification.loading) return;

    // request has been cancelled — send to the finished screen (with a cancelled
    // banner) instead of loading the form (KYC or Tranche 2)
    if (isCancelled) {
      window.location.replace(`/finish?cancelled=true`);
      return;
    }

    if (isTranche2Verification) {
      window.location.replace(`/public/tranche2/verification/${params.id}`);
    }
  }, [verification.loading, isCancelled, isTranche2Verification, params.id]);

  if (verification.loading || isCancelled || isTranche2Verification) {
    return <Loader />;
  }

  return <Verification />;
}
